import type { MouseEvent } from 'react'
import { trackPixelEvent } from './metaPixel'

/** Enlace de pago del método Curly Seducción. */
export const CHECKOUT_URL =
  'https://origenprime.com/checkouts/cn/hWNGgaT8XSKWkAcyAiZ7suJe/en-us?_r=AQAB3N1zSZ0EmRcYl0KCaQ3CrKEpc9wI7MBqPcqXHfkSeKw&cart_link_id=ppF5ynGu&preview_theme_id=143627485282'

export const PRODUCT = {
  id: 'curly-seduccion-ebook',
  name: 'Curly Seducción',
  price: 6.39,
  currency: 'USD',
}

function goToCheckout() {
  try {
    if (window.top && window.top !== window.self) {
      window.top.location.href = CHECKOUT_URL
      return
    }
  } catch {
    /* iframe de otro origen: abrimos en pestaña nueva como último recurso */
    window.open(CHECKOUT_URL, '_blank', 'noopener,noreferrer')
    return
  }

  window.location.href = CHECKOUT_URL
}

let lastAddToCart = 0

/**
 * Envía AddToCart una sola vez por clic, aunque lo disparen a la vez
 * el handler del botón y el listener global de clics.
 */
export function trackAddToCart() {
  const now = Date.now()
  if (now - lastAddToCart < 1500) return
  lastAddToCart = now

  trackPixelEvent('AddToCart', {
    content_name: PRODUCT.name,
    content_ids: [PRODUCT.id],
    content_type: 'product',
    contents: [{ id: PRODUCT.id, quantity: 1, item_price: PRODUCT.price }],
    value: PRODUCT.price,
    currency: PRODUCT.currency,
  })
}

/**
 * Registra AddToCart en el Meta Pixel y redirige al checkout de Shopify
 * en la misma pestaña. Se espera un instante para que el hit del pixel
 * alcance a salir antes de que la navegación cancele las peticiones.
 */
export function openCheckout(event?: MouseEvent<HTMLElement>) {
  event?.preventDefault()
  trackAddToCart()
  window.setTimeout(goToCheckout, 350)
}
